import React, { useEffect } from 'react';
import { useData } from '../context/DataContext';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router-dom';
import trophee1 from '../assets/img/svg/trophee.svg';
import trophee2 from '../assets/img/svg/trophee2.svg';
import trophee3 from '../assets/img/svg/trophee3.svg';

const TopJoueurs = () => {
  const { topJoueurs, topJoueursLoading, topJoueursError, fetchTopJoueurs } = useData();

  useEffect(() => {
    // Charge les données pour avoir les top joueurs
    fetchTopJoueurs();
  }, [fetchTopJoueurs]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const trophies = [trophee1, trophee2, trophee3];

  if (topJoueursError) {
    return <div>Erreur: {topJoueursError}</div>;
  }

  return (
    <div className="top-joueurs">
      <h2 className="text-center">
        Classement des joueurs
      </h2>
      {topJoueursLoading ? (
       <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement en cours...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="d-none d-md-flex justify-content-between">
            {topJoueurs.map((joueur, index) => (
              <div
                key={index}
                className="text-center mx-3"
                style={{
                  order: index === 0 ? 2 : index === 1 ? 1 : 3,
                }}
              >
                <img
                  src={trophies[index]}
                  alt={`Trophy ${index + 1}`}
                  style={{ 
                    width: '200px', 
                    height: '200px',
                    transform: index === 0 ? 'scale(1.4)' : '' 
                  }}
                />
                <h3>
                  {joueur.nom} {joueur.prenom}
                </h3>
                <p>Points: {joueur.points}</p>
              </div>
            ))}
          </div>
          <div className="d-md-none">
            <Slider {...settings}>
              {topJoueurs.map((joueur, index) => (
                <div key={index} className="text-center d-flex flex-column align-items-center">
                  <img
                    src={trophies[index]}
                    alt={`Trophy ${index + 1}`}
                    style={{ width: '200px', height: '200px'}}
                  />
                  <h3>{joueur.nom} {joueur.prenom}</h3>
                  <p>Points: {joueur.points}</p>
                </div>
              ))}
            </Slider>
          </div>
        </>
      )}
      <div className='container-btn text-center'>
        <Link className="btn btn-tree" to="/joueurs">Voir plus</Link>
      </div>
    </div>
  );
};

export default TopJoueurs;